import React from 'react';

const ClientPerformanceOverview = ({ clients }) => {
  // Calcular métricas para cada cliente
  const clientsWithMetrics = clients.map(client => {
    const totalPatients = client.meetings.reduce((total, meeting) => total + meeting.patients, 0);
    const totalContacts = client.meetings.reduce((total, meeting) => total + meeting.contactsGenerated, 0);
    const conversionRate = totalContacts > 0 ? (totalPatients / totalContacts) * 100 : 0;
    return {
      ...client,
      totalPatients,
      totalContacts,
      conversionRate: parseFloat(conversionRate.toFixed(1))
    };
  });

  // Clientes con baja tasa de conversión (ej. < 40%)
  const lowConversionClients = clientsWithMetrics
    .filter(c => c.conversionRate < 40 && c.meetings.length > 0)
    .sort((a, b) => a.conversionRate - b.conversionRate);

  // Clientes con alta tasa de conversión (ej. >= 60%)
  const highConversionClients = clientsWithMetrics
    .filter(c => c.conversionRate >= 60 && c.meetings.length > 0)
    .sort((a, b) => b.conversionRate - a.conversionRate);

  // Clientes con pocos pacientes (ej. < 5 pacientes totales)
  const lowPatientClients = clientsWithMetrics
    .filter(c => c.totalPatients < 5 && c.meetings.length > 0)
    .sort((a, b) => a.totalPatients - b.totalPatients);

  // Clientes con muchos pacientes (ej. >= 10 pacientes totales)
  const highPatientClients = clientsWithMetrics
    .filter(c => c.totalPatients >= 10 && c.meetings.length > 0)
    .sort((a, b) => b.totalPatients - a.totalPatients);

  const renderClientList = (clientList, title, metricKey, unit = '', color = '#0061A8') => {
    if (clientList.length === 0) {
      return (
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-[#0061A8]">
          <h4 className="font-medium text-[#0061A8] mb-2">{title}</h4>
          <p className="text-[#63666A] text-sm">No hay clientes en esta categoría.</p>
        </div>
      );
    }

    const maxValue = Math.max(...clientList.map(client => client[metricKey]));

    return (
      <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderColor: color }}>
        <div className="flex justify-between items-center mb-4">
          <h4 className="font-medium text-[#0061A8]">{title}</h4>
          <span className="text-sm text-[#63666A]">{clientList.length} clientes</span>
        </div>
        <div className="space-y-4">
          {clientList.map(client => (
            <div key={client.id} className="relative">
              <div className="flex justify-between text-sm mb-1">
                <div className="flex-1">
                  <span className="font-medium text-[#63666A]">{client.name}</span>
                  <div className="text-xs text-[#63666A] mt-0.5">
                    <span className="mr-4">Especialidad: {client.specialty || 'N/A'}</span>
                    <span>Célula: {client.cell || 'N/A'}</span>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="font-medium" style={{ color }}>
                    {client[metricKey]}{unit}
                  </span>
                  <div className="text-xs text-[#63666A]">
                    <div>Contactos: {client.totalContacts}</div>
                    <div>Pacientes: {client.totalPatients}</div>
                  </div>
                </div>
              </div>
              <div className="w-full bg-[#F8F9FA] rounded-full h-2">
                <div
                  className="h-2 rounded-full transition-all duration-500"
                  style={{
                    width: `${(client[metricKey] / maxValue) * 100}%`,
                    backgroundColor: color
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="mt-6 space-y-8">
      <h3 className="text-lg font-semibold text-[#0061A8]">Rendimiento de Clientes por Métrica</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {renderClientList(lowConversionClients, 'Clientes con Baja Conversión (<40%)', 'conversionRate', '%', '#FF0000')}
        {renderClientList(highConversionClients, 'Clientes con Alta Conversión (>=60%)', 'conversionRate', '%', '#A8D08D')}
        {renderClientList(lowPatientClients, 'Clientes con Pocos Pacientes (<5)', 'totalPatients', '', '#63666A')}
        {renderClientList(highPatientClients, 'Clientes con Muchos Pacientes (>=10)', 'totalPatients', '', '#0061A8')}
      </div>
    </div>
  );
};

export default ClientPerformanceOverview;
